import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { FilterEditorComponent } from "../../../filter/editor/filter-editor.component";
import { FormsModule } from "@angular/forms";
import { FrequencyService } from "../frequency.service";
import { CompositeFilter, FilterCodec } from "@teammood/filter";
import { StatsService } from "../../../analytics/stats/stats.service";
import { Digest } from "../digest.type";

@Component({
    selector: 'digest-dialog',
    templateUrl: './digest-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    FormsModule,
    TranslateModule,
    MatDialogModule,
    FilterEditorComponent
]
})
export class DigestDialogComponent implements OnInit{

    orgUnits: any;
    daysOfMonth: number[];
    daysOfWeek: {value: number, label: string}[];
    frequencies: {value: string, label: string}[];
    digest: Digest;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DigestDialogData,
        public dialogRef: MatDialogRef<DigestDialogComponent>,
        private filterCodec: FilterCodec,
        private statsService: StatsService,
        private frequencyService: FrequencyService
    ) { }

    async ngOnInit() {
        this.digest = this.data.digest;
        this.orgUnits = await this.statsService.all_org_units();
        this.daysOfMonth = this.frequencyService.getMonthDays();
        this.daysOfWeek = this.frequencyService.getWeekDays();
        this.frequencies = this.frequencyService.getFrequency();
    }

    onUpdateFrequency() {
        this.digest.dayOfDigest = undefined;
    }

    save_filters(filter: CompositeFilter) {
        this.digest.decodedFilter = filter;
        this.digest.filter = this.filterCodec.encode(filter);
    }

    create(digest: Digest) {
        const data = {
            digest: digest,
        }
        this.dialogRef.close(data);
    }

    cancel() {
        this.dialogRef.close();
    }
}


interface DigestDialogData {
    digest: Digest;
}